import { render, staticRenderFns } from "./TickSelector.vue?vue&type=template&id=32240be7&scoped=true&"
import script from "./TickSelector.vue?vue&type=script&lang=js&"
export * from "./TickSelector.vue?vue&type=script&lang=js&"
import style0 from "./TickSelector.vue?vue&type=style&index=0&id=32240be7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32240be7",
  null
  
)

export default component.exports